<div class="page-shell page-shell--canvas onboarding-page">
  <mat-toolbar class="header">
    <a class="header__brand" [href]="appBaseUrl" target="_blank" rel="noopener">
      <img
        [src]="logoLight"
        alt="DBC1"
        class="theme-logo theme-logo--light"
      />
      <img
        [src]="logoDark"
        alt=""
        class="theme-logo theme-logo--dark"
        aria-hidden="true"
      />
    </a>
    <span class="header__title">{{ "onboarding.title" | translate }}</span>
    <span class="header__domain" *ngIf="domain">{{ domain }}</span>
  </mat-toolbar>

  <div class="order-stepper-bar" *ngIf="currentStep > 1">
    <mat-stepper
      linear
      [selectedIndex]="currentStep - 2"
      class="order-stepper"
    >
      <mat-step [completed]="currentStep > 2">
        <ng-template matStepLabel>{{
          "onboarding.step1.name" | translate
        }}</ng-template>
      </mat-step>
      <mat-step [completed]="currentStep > 3">
        <ng-template matStepLabel>{{
          "onboarding.step2.name" | translate
        }}</ng-template>
      </mat-step>
      <mat-step [completed]="currentStep > 4">
        <ng-template matStepLabel>{{
          "onboarding.step3.name" | translate
        }}</ng-template>
      </mat-step>
      <mat-step [completed]="currentStep > 5">
        <ng-template matStepLabel>{{
          "onboarding.step4.name" | translate
        }}</ng-template>
      </mat-step>
    </mat-stepper>
  </div>

  <div class="dc-wrapper" *ngIf="currentStep === 1; else onboardingSteps">
    <div class="order-shell loading-shell">
      <div class="loading-card">
        <div class="profile-placeholder">
          <div class="profile-content">
            <div class="avatar">
              <mat-icon class="user-icon">person</mat-icon>
            </div>
            <div class="info-placeholder">
              <div class="name-placeholder shimmer"></div>
              <div class="title-placeholder shimmer"></div>
              <div class="contact-placeholders">
                <div class="contact-placeholder">
                  <mat-icon class="icon">phone</mat-icon>
                  <div class="line shimmer"></div>
                </div>
                <div class="contact-placeholder">
                  <mat-icon class="icon">email</mat-icon>
                  <div class="line shimmer"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="loading-status">
          <div class="loading-title">
            {{ "onboarding.fetchData.fetchingData" | translate }}
          </div>
          <div class="loading-items">
            <div class="loading-item">
              <div
                class="status-indicator"
                [class.loading]="!contactInfoLoaded"
                [class.completed]="contactInfoLoaded"
              >
                <mat-icon *ngIf="contactInfoLoaded" class="check-icon"
                  >check</mat-icon
                >
              </div>
              <div class="item-text">
                {{ "onboarding.fetchData.contactInfo" | translate }}
              </div>
            </div>
            <div class="loading-item">
              <div
                class="status-indicator"
                [class.loading]="!colorsLogoLoaded"
                [class.completed]="colorsLogoLoaded"
              >
                <mat-icon *ngIf="colorsLogoLoaded" class="check-icon"
                  >check</mat-icon
                >
              </div>
              <div class="item-text">
                {{ "onboarding.fetchData.colorsLogo" | translate }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <ng-template #onboardingSteps>
    <div class="dc-wrapper">
      <div class="order-shell">
        <div class="step-panel">
          <div class="step-shell">
            <div class="step-body">
              <div class="dc-layout">
                <section class="dc-section form-column">
                  <div class="dc-section__header">
                    <h2 class="dc-section__title" *ngIf="currentStep === 2">
                      {{ "onboarding.step1.name" | translate }}
                    </h2>
                    <h2 class="dc-section__title" *ngIf="currentStep === 3">
                      {{ "onboarding.step2.name" | translate }}
                    </h2>
                    <h2 class="dc-section__title" *ngIf="currentStep === 4">
                      {{ "onboarding.step3.name" | translate }}
                    </h2>
                    <h2 class="dc-section__title" *ngIf="currentStep === 5">
                      {{ "onboarding.step4.name" | translate }}
                    </h2>
                    <span class="dc-section__meta">{{
                      ("onboarding.step" + (currentStep - 1) + ".title")
                        | translate
                    }}</span>
                  </div>

                  <div class="dc-section__content" *ngIf="currentStep === 2">
                    <div class="form-section">
                      <div class="profile-section">
                        <div class="profile-label">
                          {{ "onboarding.step1.profilePicture" | translate }}
                        </div>
                        <app-image-uploader
                          class="profile-uploader"
                          [allowedFileExtensions]="rasterMimeTypes"
                          [previewUrl]="employeeData.profilePicture || null"
                          [previewImageStyles]="
                            'width:96px;height:96px;max-width:96px;max-height:96px;object-fit:cover;border-radius:50%;'
                          "
                          [description]="
                            'onboarding.step1.addPicture' | translate
                          "
                          (onFileChange)="onProfileImageChange($event)"
                          (onFileRemove)="removeProfilePicture()"
                        ></app-image-uploader>
                      </div>

                      <div
                        class="form-group"
                        *ngFor="let field of basicInfoFields"
                      >
                        <mat-form-field
                          appearance="outline"
                          class="search-field"
                          *ngIf="field.model !== 'phone'"
                          subscriptSizing="dynamic"
                        >
                          <mat-label>{{ field.label | translate }}</mat-label>
                          <input
                            matInput
                            [type]="field.type"
                            [(ngModel)]="employeeData[field.model]"
                            (ngModelChange)="onFieldChange(field.model)"
                            [placeholder]="field.placeholder | translate"
                            [disabled]="field.disabled"
                          />
                          <mat-hint *ngIf="field.hint">{{
                            field.hint | translate
                          }}</mat-hint>
                        </mat-form-field>

                        <app-phone-input
                          *ngIf="field.model === 'phone'"
                          [label]="field.label | translate"
                          [placeholder]="field.placeholder | translate"
                          [disabled]="field.disabled"
                          [(ngModel)]="employeeData[field.model]"
                          (ngModelChange)="onFieldChange(field.model)"
                        >
                        </app-phone-input>
                      </div>
                    </div>
                  </div>

                  <div class="dc-section__content" *ngIf="currentStep === 3">
                    <app-social-media
                      #socialMediaComponent
                      [socialMediaData]="socialMedia"
                      [employeeData]="employeeData"
                      [domain]="domain"
                      [brandColor]="brandColor"
                      [selectedIcons]="selectedSocialMediaIcons"
                      [showAllSocialIcons]="showAllSocialIcons"
                      (socialMediaChange)="onSocialMediaChange($event)"
                      (employeeDataChange)="onEmployeeDataChange($event)"
                      (domainChange)="onDomainChange($event)"
                      (selectedIconsChange)="onSelectedIconsChange($event)"
                      (showAllSocialIconsChange)="
                        onShowAllSocialIconsChange($event)
                      "
                      (addCustomIconClick)="showAddCustomIconForm()"
                    >
                    </app-social-media>
                  </div>

                  <div class="dc-section__content" *ngIf="currentStep === 4">
                    <div class="addons-grid">
                      <div
                        class="addon-card"
                        *ngFor="let addon of addonTypes"
                      >
                        <div class="addon-header">
                          <mat-icon>{{ addon.icon }}</mat-icon>
                          <h4>{{ addon.title }}</h4>
                          <div class="addon-actions">
                            <button
                              *ngIf="selectedAddons[addon.key]"
                              mat-stroked-button
                              type="button"
                              class="edit-btn"
                              (click)="editAddon(addon, selectedAddons[addon.key])"
                            >
                              <mat-icon>edit</mat-icon>
                              {{ "edit" | translate }}
                            </button>
                            <button
                              mat-stroked-button
                              type="button"
                              class="add-new-btn"
                              (click)="addon.addMethod()"
                              color="primary"
                            >
                              <mat-icon>add</mat-icon>
                              {{ "onboarding.step3.addNew" | translate }}
                            </button>
                          </div>
                        </div>
                        <div class="addon-content">
                          <mat-form-field
                            appearance="outline"
                            subscriptSizing="dynamic"
                          >
                            <mat-label
                              >{{ "onboarding.step3.select" | translate }}
                              {{ addon.title }}</mat-label
                            >
                            <mat-select
                              [(ngModel)]="selectedAddons[addon.key]"
                              (ngModelChange)="onAddonChange()"
                            >
                              <mat-option [value]="null">{{
                                "onboarding.step3.none" | translate
                              }}</mat-option>
                              <mat-option
                                *ngFor="
                                  let item of availableAddons[addon.plural]
                                "
                                [value]="item.addonId"
                              >
                                {{
                                  item.data?.name ||
                                    item.data?.url ||
                                    item.data?.htmlContent
                                }}
                              </mat-option>
                            </mat-select>
                          </mat-form-field>
                        </div>

                        <div
                          *ngIf="
                            addon.key === 'bannerId' &&
                            !showAdditionalBannerSection
                          "
                          class="additional-banner-button"
                        >
                          <button
                            mat-stroked-button
                            type="button"
                            (click)="toggleAdditionalBannerSection()"
                            color="primary"
                          >
                            <mat-icon>add</mat-icon>
                            {{
                              "onboarding.step3.addAdditionalBanner" | translate
                            }}
                          </button>
                        </div>

                        <div
                          *ngIf="addon.key === 'additionalBannerId'"
                          class="additional-banner-close"
                        >
                          <button
                            mat-icon-button
                            type="button"
                            (click)="hideAdditionalBannerSection()"
                            class="close-button"
                            [attr.title]="
                              'onboarding.step3.removeAdditionalBanner'
                                | translate
                            "
                          >
                            <mat-icon>close</mat-icon>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="dc-section__content" *ngIf="currentStep === 5">
                    <div class="completion-summary">
                      <div
                        class="summary-item"
                        *ngFor="let item of completionItems"
                      >
                        <mat-icon>check_circle</mat-icon>
                        <span>
                          <ng-container *ngIf="item.value; else textOnly">
                            {{ item.text | translate }}: {{ item.value }}
                          </ng-container>
                          <ng-template #textOnly>
                            {{ item.text | translate }}
                          </ng-template>
                        </span>
                      </div>
                    </div>
                  </div>
                </section>

                <section class="dc-section preview-column">
                  <div class="dc-section__header">
                    <h2 class="dc-section__title">
                      {{ "onboarding.step4.emailPreview" | translate }}
                    </h2>
                  </div>
                  <div class="dc-section__content preview-content">
                    <div class="browser-header">
                      <div class="window-controls">
                        <div class="control close"></div>
                        <div class="control minimize"></div>
                        <div class="control maximize"></div>
                      </div>
                    </div>
                    <div class="signature-content">
                      <div
                        [innerHTML]="
                          signatureHtmlWithAddons || signatureHtml
                        "
                      ></div>
                    </div>
                  </div>
                </section>
              </div>
            </div>

            <div class="step-actions">
              <button
                *ngIf="currentStep > 2"
                mat-stroked-button
                type="button"
                (click)="previousStep()"
                [disabled]="isLoading"
              >
                <mat-icon>arrow_back</mat-icon>
                {{ "onboarding.navigation.back" | translate }}
              </button>

              <div class="step-actions__status"></div>

              <button
                *ngIf="currentStep > 1"
                mat-stroked-button
                type="button"
                (click)="saveAndInstallLater()"
                [disabled]="isLoading"
              >
                <mat-spinner
                  *ngIf="isLoading"
                  diameter="20"
                  class="dc-btn-spinner"
                ></mat-spinner>
                <mat-icon *ngIf="!isLoading">library_add</mat-icon>
                {{
                  isLoading
                    ? ("onboarding.navigation.installing" | translate)
                    : ("onboarding.navigation.saveAndInstallLater" | translate)
                }}
              </button>

              <button
                *ngIf="currentStep === 2"
                mat-raised-button
                color="primary"
                type="button"
                (click)="nextStep()"
                [disabled]="!canProceedToNextStep()"
              >
                {{ "onboarding.navigation.continue" | translate }}
                <mat-icon>arrow_forward</mat-icon>
              </button>

              <button
                *ngIf="currentStep < totalSteps && currentStep > 2"
                mat-raised-button
                color="primary"
                type="button"
                (click)="nextStep()"
                [disabled]="isLoading || !canProceedToNextStep()"
              >
                {{ "onboarding.navigation.continue" | translate }}
                <mat-icon>arrow_forward</mat-icon>
              </button>

              <button
                *ngIf="currentStep === totalSteps"
                mat-raised-button
                color="primary"
                type="button"
                (click)="completeOnboarding()"
                [disabled]="isLoading"
              >
                <mat-spinner
                  *ngIf="isLoading"
                  diameter="20"
                  class="dc-btn-spinner"
                ></mat-spinner>
                <mat-icon *ngIf="!isLoading">save</mat-icon>
                {{
                  isLoading
                    ? ("onboarding.navigation.installing" | translate)
                    : ("onboarding.navigation.install" | translate)
                }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</div>
